import PropTypes from 'prop-types';
import cx from 'classnames';
import './title.scss';

const Title = ({ titlePrefix = null, className = '', children }) => {
  return (
    <h1 className={cx('gw-title', className )}>
      {titlePrefix && `${titlePrefix} `}
      <span itemProp="name">{children}</span>
    </h1>
  );
};

Title.propTypes = {
  titlePrefix: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Title;
